$container = '.timeline-projects'
$project =  '.timeline-project'
$title = $('.project-name')
$title.hover ->
  $(@).closest($container).find($project).addClass('project-hide')
  $(@).parent().removeClass('project-hide')
  $(@).parent().addClass('project-hovered')
, ->
  $(@).closest($container).find($project).removeClass('project-hide')
  $(@).parent().removeClass('project-hovered')
